import { Colors, Services } from '@sigma-frontend-libs/commons'
import { TaskStates } from '@sigmasms/shared-types'

import { buttonModes, components, icons, popperPlacements } from '@/utils'

import button from '@/components/button'
import buttonConfirmRemove from '@/components/button/confirm/remove'
import eventsHistoryDialog from '@/components/services/eventsHistory/dialog'
import analytics from '@/components/services/tasks/analytics'
import sourceBox from '@/components/source/box'

function renderSourceDataDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate('commons.titles.data'),
        value: this.showSourceDataDialog,
        maxWidth: 1000
      },
      on: {
        input: event => {
          this.showSourceDataDialog = event
        }
      }
    },
    [
      h(
        sourceBox,
        {
          props: {
            value: this.value,
            rounded: false
          },
          on: {
            close: event => {
              this.showSourceDataDialog = event
            }
          }
        }
      ),
      h(
        'div',
        {
          class: 'dialog__footer',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.close'),
                mode: buttonModes.flat
              },
              on: {
                click: () => {
                  this.showSourceDataDialog = false
                }
              }
            }
          )
        ]
      )
    ]
  )
}
function renderSourceListItem(h) {
  if (this.canRemoveTasksAsAdmin) {
    return h(
      components['list-item'],
      {
        props: {
          label: this.getTranslate('misc.sourceData'),
          icon: icons.code,
          iconColor: Colors.primary,
          dense: true
        },
        on: {
          click: () => {
            this.showSourceDataDialog = !this.showSourceDataDialog
          }
        }
      }
    )
  }
}

function renderStatisticListItem(h) {
  if (this.hasAnalytics) {
    return h(
      components['list-item'],
      {
        props: {
          label: this.getTranslate(`${Services.tasks}.labels.analytics`),
          icon: icons.assessment,
          dense: true,
          link: true,
          to: this.analyticsTo
        }
      }
    )
  }
}

function renderRemoveListItem(h) {
  if (this.canGetTasksAsMeUp) {
    switch (this.value.state) {
      case TaskStates.running:
      case TaskStates.scheduled: return
      default: {
        return h(
          buttonConfirmRemove,
          {
            props: {
              component: components['list-item'],
              callback: () => {
                return this.remove()
              }
            }
          }
        )
      }
    }
  }
}

function renderEventsHistoryDialog(h) {
  return h(
    eventsHistoryDialog,
    {
      props: {
        entityId: this.value.id,
        value: this.showEventsHistoryDialog
      },
      on: {
        input: event => {
          this.showEventsHistoryDialog = event
        }
      }
    }
  )
}

function renderEventsHistoryListItem(h) {
  if (this.canGetHistoryAsAdmin) {
    return h(
      components['list-item'],
      {
        props: {
          label: this.getTranslate(`${Services.eventsHistory}.title`),
          icon: icons.manage_history,
          dense: true
        },
        on: {
          click: () => {
            this.showEventsHistoryDialog = !this.showEventsHistoryDialog
          }
        }
      }
    )
  }
}

export default function(h) {
  return h(
    components.menu,
    {
      props: {
        value: this.showMenu,
        rounded: true,
        offsetDistance: 8,
        placement: popperPlacements['bottom-end']
      },
      on: {
        input: event => {
          this.showMenu = event
        }
      }
    },
    [
      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            icon: icons.more_vert
          },
          slot: 'activator'
        }
      ),

      h(
        components.list,
        {
          props: {
            dense: true,
            rounded: true
          }
        },
        [
          renderSourceListItem.call(this, h),
          renderStatisticListItem.call(this, h),
          h(analytics, { props: { value: this.value } }),
          renderEventsHistoryListItem.call(this, h),
          renderRemoveListItem.call(this, h)
        ]
      ),

      renderSourceDataDialog.call(this, h),
      renderEventsHistoryDialog.call(this, h)
    ]
  )
}
